import React from 'react';
import { render } from 'react-dom';
import { ready } from 'core-utilities';
import { rootElementId } from './app.config';
import App from './App';
import '../../../css/subscriptionPage/subscriptionPage.scss';

ready(() => {
  const rootElement = document.getElementById(rootElementId);
  if (rootElement) {
    render(<App />, rootElement);
  }
});
